<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main-master" [class.platform-large-text]="getTextSize()">
  <!-- タイトル -->
  <div class="page-title" *ngIf="header">
    <label class="name">{{header}}</label>
  </div>
  <!-- メイン領域-->
  <mat-drawer-container class="main-container" autosize>
    <!-- 一覧画面表示領域-->
    <p-table
      #table
      [value]="searchResultsList"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first}~{last}件表示({totalRecords}件中)"
      [rowsPerPageOptions]="[10, 50, 100, 500, 1000]"
      emptyMessage="データが存在しません"
      styleClass="p-datatable-striped master-datatable"
      selectionMode="single"
      [scrollable]="true"
      scrollHeight="480px"
      scrollWidth="100vw"
    >
      <ng-template pTemplate="caption">
        <div class="p-d-flex p-jc-between">
          <div class="p-d-flex">
            <!-- 検索画面表示-->
            <button
              type="button"
              pButton
              icon="pi pi-search"
              (click)="search.toggle()"
              class="p-mr-2"
              pTooltip="検索"
              tooltipPosition="bottom"
            ></button>
          </div>
          <div class="p-as-center p-d-flex">
            <div *ngIf="mailmagazineList">
              <!-- メルマガ一覧出力-->
              <button
                type="button"
                pButton
                label="メルマガ一覧出力"
                (click)="exportmailmagazineCSV()"
                class="p-mr-2 mail_button"
                tooltipPosition="bottom"
              ></button>
            </div>
            <!-- 全件csv出力-->
            <button
              type="button"
              pButton
              label="CSV"
              (click)="exportCSV()"
              class="p-mr-2"
              pTooltip="全件CSV"
              tooltipPosition="bottom"
            ></button>
          </div>
        </div>
      </ng-template>

      <!-- 一覧画面ヘッダー表示-->
      <ng-template pTemplate="header">
        <tr class="p-col-2">
          <!-- APIヘッダーの表示 -->
          <ng-container *ngFor="let column of columnOrder; index as i">
            <th [pSortableColumn]="column.field" [ngClass]="{'col-1-7':(router?.url.startsWith('/pages/platform/master/f121'))&& i < 8, 'col-normal':(router?.url.startsWith('/pages/platform/master/f121'))&& i >= 8}">
              {{ column.header }}
              <p-sortIcon [field]="column.field"></p-sortIcon>
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <!-- 一覧画面ボディ表示-->
      <ng-template pTemplate="body" let-searchResults>
        <tr>
          <!-- 一覧表示-->
          <ng-container *ngFor="let column of columnOrder; index as i">
            <!-- 一覧項目値表示(詳細画面遷移項目) -->
            <td
              class="transitionDetail"
              (click)="detail(searchResults[getPkeyColumn()])"
              *ngIf="'P' == column.column_pkey; else notPkey"
              [ngClass]="{'col-1-7':(router?.url.startsWith('/pages/platform/master/f121'))&& i < 8, 'col-normal':(router?.url.startsWith('/pages/platform/master/f121'))&& i >= 8}"
            >
              <u>{{ searchResults[column.field] }}</u>
            </td>
            <!-- 一覧項目値表示 -->
            <ng-template #notPkey>
              <td [ngSwitch]="column?.input_type" [ngClass]="{'col-1-7':(router?.url.startsWith('/pages/platform/master/f121'))&& i < 8, 'col-normal':(router?.url.startsWith('/pages/platform/master/f121'))&& i >= 8}">
                <span *ngSwitchCase="'NUMBER'">
                  {{ searchResults[column.field] | number }}
                </span>
                <span *ngSwitchDefault>
                  {{ searchResults[column.field] }}
                </span>
              </td>
            </ng-template>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>

    <!-- 検索画面-->
    <mat-drawer #search class="search-sidenav" mode="side">
      <!-- 検索画面非表示-->
      <button
        type="button"
        pButton
        icon="pi pi-arrow-left"
        (click)="search.toggle()"
        class="p-mr-2 search-sidenav-hide"
      ></button>

      <!-- 検索画面[検索項目生成(アイテムアダプター)]-->
      <app-generate-search
        [searchEndPoint]="searchEndPoint"
        [searchTemplateId]="searchTemplateId"
        (generateSearchInformation)="searchResult($event)"
      ></app-generate-search>
    </mat-drawer>
  </mat-drawer-container>
</div>

<!-- 詳細画面[表示項目生成(アイテムアダプター)]-->
<app-generate-display></app-generate-display>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
